import { render, staticRenderFns } from "./StorySlide.vue?vue&type=template&id=141c4310&scoped=true&"
import script from "./StorySlide.vue?vue&type=script&lang=ts&"
export * from "./StorySlide.vue?vue&type=script&lang=ts&"
import style0 from "./StorySlide.vue?vue&type=style&index=0&id=141c4310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141c4310",
  null
  
)

export default component.exports